import { Row, Col, InputNumber } from 'antd';
import * as React from 'react';

import StateContainer from '../StateContainer';
import { FormItem } from '../../../../components/Form';
import CountryTree from '../../../../components/Others/CountryTree';
import CustomerGroupTree from '../../../../components/Others/CustomerGroupTree';

export interface IProductAdvancedTabProps {
  container: StateContainer;
}

interface IProductAdvancedTabState {
  hideForCountry: string[];
  visibleForCustomerGroup: string[];
}

export class ProductAdvancedTab extends React.Component<IProductAdvancedTabProps, IProductAdvancedTabState> {

  constructor(props: IProductAdvancedTabProps) {
    super(props);

    this.state = {
      hideForCountry: props.container &&
        props.container.state &&
        props.container.state.product &&
        props.container.state.product.hideForCountry 
          ? props.container.state.product.hideForCountry 
          : [],
      visibleForCustomerGroup: props.container &&
        props.container.state &&
        props.container.state.product &&
        props.container.state.product.visibleForCustomerGroup 
          ? props.container.state.product.visibleForCustomerGroup 
          : [],
    }

    this.onChange = this.onChange.bind(this);
  }

  public render() {
    return (
      <>
        <Row gutter={30} className={'ant-form-advanced'}>
          <Col span={6}>
            <FormItem label={'Hide for countries'}>
              <CountryTree 
                name={'hideForCountry'}
                onChange={(e: any, countries: GQL.ICountry[]) => this.onChange(e)}
                value={this.state.hideForCountry || []}
              />
            </FormItem>
          </Col>
          <Col span={6}>
            <FormItem label={'Visible only for groups'}>
              <CustomerGroupTree
                name={'visibleForCustomerGroup'}
                onChange={(e: any, customerGroups: GQL.ICustomerGroup[]) => this.onChange(e)}
                value={this.state.visibleForCustomerGroup || []}
              />
            </FormItem>
          </Col>
        </Row>
        <Row gutter={30}>
          <Col>
          <FormItem label={'Purchase limit'}>
            <InputNumber
              name={'purchaseLimitPerPurchase'}
              defaultValue={this.props.container && this.props.container.state && this.props.container.state.product && this.props.container.state.product.purchaseLimitPerPurchase || undefined}
              onChange={(value) => {
                if ('number' === typeof value) {
                  if (value < 0) {
                    value = 0;
                  }
                } else {
                  value = undefined;
                }
                this.onChange({ target:{
                  name: 'purchaseLimitPerPurchase',
                  value: value || null
                }});
              }}
            />
          </FormItem>
          </Col>
        </Row>
      </>
    );
  }

  private onChange(e: any) {
    const { name, value } = e.target;

    this.setState({
      ...this.state, [name]: value,
    }, () => {
      this.props.container.onChange(name, value);
    });
  }
}



// WEBPACK FOOTER //
// ./src/scenes/Products/ProductDetail/ProductAdvancedTab/ProductAdvancedTab.tsx